import * as React from 'react'

import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'

const PaymentActionRequiredModal = () => (
  <Modal
    illustration="money-bag"
    locked
    title={i18n.t('billing.action_required.title')}
    description={i18n.t('billing.action_required.description')}
  />
)

export default PaymentActionRequiredModal
